(() => {
    // Excludes the auth header (id="header"), which has a static cream chrome.
    const header = document.querySelector('header[data-theme]:not(#header)');
    if (!header) return;

    const hero = document.querySelector('.block-hero');
    if (!hero) return;

    const headerHeight = header.offsetHeight || 96;

    const mobileMenu = document.querySelector('[data-mobile-menu]');

    // rootMargin = -headerHeight excludes the fixed header zone from the intersection rect,
    // so the observer fires when the Hero's bottom edge crosses the header's bottom.
    const observer = new IntersectionObserver(([entry]) => {
        const theme = entry.isIntersecting ? 'light' : 'dark';
        header.setAttribute('data-theme', theme);
        if (mobileMenu) {
            mobileMenu.setAttribute('data-theme', theme);
        }
    }, {
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
        threshold: 0,
    });

    observer.observe(hero);
})();
